import AccetazionePazienteImpegnative from "../index.js";
const routes = [
    {
        name: "Rsa Paziente Impegnative",
        path: "/rsapaziente/impegnative",
        component: AccetazionePazienteImpegnative.AccettazionePazienteImpegnativePage,
        meta: { title: "Accettazione Paziente Impegnative" },
    },
    {
        name: "Rsa Paziente Appuntamenti",
        path: "/rsapaziente/appuntamenti",
        component: AccetazionePazienteImpegnative.AccettazionePazienteAppuntamentiPage,
        meta: { title: "Accettazione Paziente Impegnative" },
    },
];

export default routes;
